/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaAudioVolumeS2Icon24Solid = forwardRef('MediaAudioVolumeS2Icon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m5.571 8 4.941-4.323c.97-.849 2.488-.16 2.488 1.129v14.388c0 1.29-1.518 1.978-2.488 1.13L5.572 16H3a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.571Z" }),
        React.createElement("path", { d: "M18.364 4.222a1 1 0 0 1 1.414 0 11 11 0 0 1 0 15.556 1 1 0 0 1-1.414-1.414 9 9 0 0 0 0-12.728 1 1 0 0 1 0-1.414Z" }),
        React.createElement("path", { d: "M16.773 7.227a1 1 0 1 0-1.414 1.414 4.751 4.751 0 0 1 0 6.718 1 1 0 1 0 1.414 1.414 6.75 6.75 0 0 0 0-9.546Z" })));
});
